import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import { usePreferences } from '../../../hooks/usePreferences';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
  GENERAL_DL_SWITCH_CLASS,
} from '../PriceViewer';

const HSISwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
}> = ({ wrapAnalytics }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    showHSIPE,
    showHSIPB,
    showHSIDividend,
    showHSIShortRatio,
    showHSIFundamental,
  } = usePreferences();
  return (
    <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
      <div
        className={classNames(GENERAL_DL_SWITCH_CLASS, {
          checked: showHSIFundamental,
        })}
        onClick={wrapAnalytics('hsi-fundamentals', () =>
          dispatch(preferenceActions.setHSIFundamental(!showHSIFundamental))
        )}
      >
        {t('Fundamental')}
      </div>
      <div
        className={classNames(DL_SWITCH_CLASS_NAME, {
          checked: showHSIPE,
          disabled: !showHSIFundamental,
        })}
        onClick={wrapAnalytics('hsipe', () => {
          dispatch(preferenceActions.setPriceViewerHSIPE(!showHSIPE));
        })}
        style={showHSIFundamental ? { color: '#ca6702' } : { color: '#e9c299' }}
      >
        {t('PE')}
      </div>
      <div
        className={classNames(DL_SWITCH_CLASS_NAME, {
          checked: showHSIPB,
          disabled: !showHSIFundamental,
        })}
        onClick={wrapAnalytics('hsipb', () => {
          dispatch(preferenceActions.setPriceViewerHSIPB(!showHSIPB));
        })}
        style={showHSIFundamental ? { color: '#53E055' } : { color: '#baf2bb' }}
      >
        {t('PB')}
      </div>
      <div
        className={classNames(DL_SWITCH_CLASS_NAME, {
          checked: showHSIDividend,
          disabled: !showHSIFundamental,
        })}
        onClick={wrapAnalytics('hsi-dividend', () => {
          dispatch(
            preferenceActions.setPriceViewerHSIDividend(!showHSIDividend)
          );
        })}
        style={showHSIFundamental ? { color: '#039BE5' } : { color: '#9ad7f4' }}
      >
        {t('dividend-yield')}
      </div>
      <div
        className={classNames(DL_SWITCH_CLASS_NAME, {
          checked: showHSIShortRatio,
          disabled: !showHSIFundamental,
        })}
        onClick={wrapAnalytics('hsi-short-ratio', () => {
          dispatch(
            preferenceActions.setPriceViewerHSIShortRatio(!showHSIShortRatio)
          );
        })}
        style={showHSIFundamental ? { color: '#F5C292' } : { color: '#fbe6d3' }}
      >
        {t('short-ratio')}
      </div>
    </div>
  );
};

export default HSISwitch;
